import { render, staticRenderFns } from "./customNav.vue?vue&type=template&id=86e7a75c&scoped=true"
import script from "./customNav.vue?vue&type=script&lang=js"
export * from "./customNav.vue?vue&type=script&lang=js"
import style0 from "./customNav.vue?vue&type=style&index=0&id=86e7a75c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e7a75c",
  null
  
)

export default component.exports